import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
const risingStars = [{
  id: 1,
  name: "Managed IT Support",
  role: "24/7 Peace of Mind",
  bio: "Our comprehensive Annual Maintenance Contracts (AMC) provide proactive monitoring and rapid response. We act as your silent engine, ensuring your digital infrastructure remains resilient and scales with your ambition.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_masters_operations.png",
  link: "/ServicesPage"
}, {
  id: 2,
  name: "Hospitality IT",
  role: "Specialized Solutions",
  bio: "Trusted by Marriott and Sheraton, we manage high-stakes virtualization projects. We understand that in luxury hospitality, downtime is not an option, delivering precision technology for guest services and back-office.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/hospitality_server_room.png",
  link: "/HospitalityPage"
}, {
  id: 3,
  name: "Cybersecurity",
  role: "Gold-Standard Protection",
  bio: "Partnered with world-leading firms to implement edge-to-edge encryption and proactive threat hunting. We ensure your data and reputation remain untouchable through architected, multi-tier security frameworks.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/cybersecurity_infrastructure.png",
  link: "/ServicesPage"
}];
export default function PerfisEmAscensao() {
  return <section data-section-id="223496" id="managed-it-amc" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.05] mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-2xl">
          <h2 className="font-default text-3xl font-bold tracking-tighter md:text-5xl">
            Managed IT & AMC
          </h2>
          <p className="mt-4 text-lg text-muted-foreground font-serif">
            Precision technology and proven excellence since 2014. We architect resilient infrastructure that powers leading enterprises across the UAE.
          </p>
        </div>

        <div className="flex h-[1200px] w-full flex-col gap-4 lg:h-[700px] lg:flex-row">
          {risingStars.map((star, i) => <div key={star.id} data-index={i} className="group relative flex flex-1 cursor-pointer flex-col overflow-hidden rounded-md bg-card border border-border transition-all duration-700 ease-in-out hover:flex-[2] lg:hover:flex-[2.5] shadow-md">
              {}
              <img src={star.image} alt={`Infrastructure visualization for ${star.name}`} className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105 grayscale hover:grayscale-0" />

              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-95" />

              {}
              <div className="relative mt-auto flex flex-col justify-end p-6 md:p-8">
                <span className="mb-3 text-xs font-mono font-semibold uppercase tracking-widest text-primary">
                  {star.role}
                </span>
                
                <h3 className="font-default text-3xl font-bold leading-none text-foreground md:text-4xl lg:text-5xl tracking-tighter">
                  {star.name}
                </h3>

                {}
                <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-in-out group-hover:grid-rows-[1fr]">
                  <div className="overflow-hidden">
                    <p className="font-serif mt-4 text-sm leading-relaxed text-muted-foreground md:text-base">
                      {star.bio}
                    </p>
                    
                    <div className="mt-6 opacity-0 transition-opacity duration-500 delay-100 group-hover:opacity-100">
                      <Button asChild variant="outline" className="group/btn border-primary/30 rounded-md hover:bg-primary hover:text-primary-foreground transition-all">
                        <Link to={star.link}>
                          Explore Service Details
                          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover/btn:translate-x-1" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}